


import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";

// import img1 from "../Assessts/slideHome_images/mainimg5.png";
import img1 from "../Assessts/slideHome_images/mainimg6.png";
// import img2 from "../Assessts/slideHome_images/4Airforce.png";
import img2 from "../Assessts/slideHome_images/aerospace1.jpg";
// import img3 from "../Assessts/slideHome_images/army4.png";
import img3 from "../Assessts/slideHome_images/army5.png";
// import img4 from "../Assessts/slideHome_images/navy3.png";
import img4 from "../Assessts/slideHome_images/navy2.jpg";
// import img5 from "../Assessts/slideHome_images/railway5.png";
import img5 from "../Assessts/slideHome_images/Railway4.png";
// import img6 from "../Assessts/slideHome_images/6uav2.jpg";
import img6 from "../Assessts/slideHome_images/uav1.png";
// Placeholder for new Airforce image
import imgAirforce from "../Assessts/slideHome_images/2Airforce.jpeg"; // replace with actual image path

import AboutSection from "../components/AboutSection";
import WhyTechnocratSection from "../components/WhyTechnocratSection";
import ServicesAndStats from "../components/ServicesAndStats";
import ValuableClients from "../components/valuableClients";
import IndustrySectors from "../components/IndustrySectors";
import MadeInIndia from "../components/MadeInIndia";
import Events from "../components/EventsExabtionss";

export default function HomePage() {
  return (
    <div>
      {/* Carousel Section */}
      <Carousel interval={4000} fade>
        {/* Slide 1 – Technocrat Aerospace & Defence */}
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={img1}
            alt="Technocrat Aerospace & Defence"
            style={{ height: "70vh", objectFit: "cover" }}
          />
          <Carousel.Caption   >
            <h3>Technocrat Aerospace And Defence</h3>
            <p style={{
    textAlign: "left",
    left: "5%",
    right: "auto",
    transform: "none",
  }}>
              Technocrat Aerospace and Defence Pvt. Ltd. stands at the forefront
              of India’s strategic technology ecosystem. We design and
              manufacture high-reliability electronic systems, including
              ruggedized PCBs, power management units, precision sensors,
              embedded control systems, and mission-critical communication
              modules. Our indigenous solutions ensure superior performance,
              durability, and interoperability across defence, aerospace, and
              transport applications.
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Slide 2 – Airforce */}
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={imgAirforce}
            alt="Airforce"
            style={{ height: "70vh", objectFit: "cover" }}
          />
          <Carousel.Caption>
            <h3>Airforce</h3>
            <p style={{
    textAlign: "left",
    left: "5%",
    right: "auto",
    transform: "none",
  }}>
Technocrat Aerospace and Defence Private Limited supplies a range of advanced aerospace products and systems specifically for the Indian Air Force (IAF). Their offerings include data acquisition (DAQ) systems for test and telemetry, RF modules utilized in radar and communication systems, rugged commercial off-the-shelf (COTS) hardware designed to perform in harsh environments, and cockpit controls with customizable layouts. 
            </p>
          </Carousel.Caption> 
        </Carousel.Item>

        {/* Slide 3 – Navy */}
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={img4}
            alt="Navy"
            style={{ height: "70vh", objectFit: "cover" }}
          />
          <Carousel.Caption>
            <h3>Navy</h3>
            <p style={{
    textAlign: "left",
    left: "5%",
    right: "auto",
    transform: "none",
  }}>
              For naval and maritime applications, Technocrat designs sonar
              integration systems, navigation control modules, and intelligent
              power management solutions capable of operating under high
              humidity, pressure, and salinity. Our marine-grade electronics are
              engineered for anti-corrosion performance and vibration
              resilience, supporting surveillance, communication, and combat
              systems across ships, submarines, and coastal platforms.
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Slide 4 – Army */}
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={img3}
            alt="Army"
            style={{ height: "70vh", objectFit: "cover" }}
          />
          <Carousel.Caption>
            <h3>Army</h3>
            <p style={{
    textAlign: "left",
    left: "5%",
    right: "auto",
    transform: "none",
  }}>
              Technocrat provides battlefield-proven electronics and embedded
              systems tailored for land-based defence operations. Our product
              range includes tactical communication systems, rugged computing
              devices, power conditioning units, and environmental monitoring
              sensors. Built to operate in extreme terrains, our systems deliver
              real-time data, robust connectivity, and mission readiness for the
              Indian Army’s modern field operations.
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Slide 5 – Aerospace */}
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={img2}
            alt="Aerospace"
            style={{ height: "70vh", objectFit: "cover" }}
          />
          <Carousel.Caption>
            <h3>Aerospace</h3>
            <p style={{
    textAlign: "left",
    left: "5%",
    right: "auto",
    transform: "none",
  }}>
              In the Aerospace, Technocrat develops avionics, radar
               interfaces, flight data systems, and mission control modules that
               meet the stringent standards of aerial operations. Our systems
               enhance communication, navigation, and situational awareness in
               both manned and unmanned aerial vehicles (UAVs). Designed for
               extreme altitudes, vibrations, and temperature ranges, our
               aerospace-grade electronics ensure accuracy, reliability, and
              safety in every mission.
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        {/* slide 6 for UAV*/}
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={img6}
            alt="UAV's"
            style={{ height: "70vh", objectFit: "cover" }}
          />
          <Carousel.Caption>
            <h3>Drones & UAV's</h3>
            <p style={{
    textAlign: "left",
    left: "5%",
    right: "auto",
    transform: "none",
  }}>
              Technocrat Aerospace & Defence (TAAD) develops and supplies electronics products tailored for drone and UAV (unmanned aerial vehicle) applications. Their offerings include advanced sensor assemblies, vision systems, laser inspection systems, and electro-optical/infrared (EO/IR) gimbals designed for guidance, targeting, surveillance, and reconnaissance missions. TAAD also provides ruggedized control wheels, grips, and connection systems that ensure reliable operation in drone platforms. 
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Slide 7 – Railways */}
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={img5}
            alt="Railways"
            style={{ height: "70vh", objectFit: "cover" }}
          />
          <Carousel.Caption>
            <h3>Railways</h3>
            <p style={{
    textAlign: "left",
    left: "5%",
    right: "auto",
    transform: "none",
  }}>
               In the railway, Technocrat delivers advanced signalling
               systems, onboard diagnostic electronics, condition monitoring
               units, and smart power distribution modules. Our cutting-edge
               solutions support automation, safety, and energy efficiency in
               modern rail networks. Through innovation and reliability, we
               contribute to India’s railway modernization and smart
               infrastructure goals, ensuring smoother, safer, and more
               sustainable transportation.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>

      {/* Other Sections */}
      <IndustrySectors />
      <AboutSection />
      <WhyTechnocratSection />
      <MadeInIndia />
      <ServicesAndStats />
      <ValuableClients />
      <Events/>
    </div>
  );
}
